import { formatDate } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  format(date: Date, format: string): string {
    return formatDate(date, format, this.locale);
  }

  formatISO8601(date: Date): string {
    return formatDate(date, 'yyyy-MM-ddTHH:mm:ss', this.locale);
  }

  parseDateForm({ date, time }: { date: Date; time: string }): string | null {
    if (!date) return null;
    const dateString = this.format(date, 'yyyy-MM-dd');
    return `${dateString}T${time || '00:00'}:00`;
  }

  parseFormToDate(datetime: FormGroup): Date | undefined {
    const { date, time } = datetime.value;
    if (datetime.invalid || !date || !time) return;

    const dateString = this.format(date, 'yyyy-MM-dd');
    return new Date(`${dateString}T${time}`);
  }

  getDateList(start: Date, end: Date): Date[] {
    const dateList: Date[] = [];
    let dateTemp: Date = new Date(start.getTime());
    dateTemp.setHours(0);
    dateTemp.setMinutes(0);
    dateTemp.setSeconds(0);
    dateTemp.setMilliseconds(0);
    do {
      dateList.push(new Date(dateTemp.getTime()));
      dateTemp.setDate(dateTemp.getDate() + 1);
    } while (dateTemp.getTime() <= end.getTime());
    return dateList;
  }

  getMinutesLater(date: Date, num: number) {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() + num);
    return d;
  }

  getMinDate(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() - 3, 1);
  }

  getMaxDate(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() + 4, 0);
  }
}
